
















































// Importing components
import BaseAlertList from '@/ui/BaseAlertList.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';

export default {
    name: 'TheFormAddress',
    components: {
        TheTownSelect,
        BaseAlertList,
        BaseInputField,
        BaseLoadingAnimation,
    },
    props: {
        address: Object,
        errors: Array,
    },
    data() {
        return {};
    },
};
